import React, { Component } from 'react';
import './CardTab.scss';

class CardTab extends Component {
  constructor(props) {
    super(props)
    this.state = {
      botao: false,
    }
  }

  toggleSaibaMais = () => {
    this.setState({
      botao: !this.state.botao
    })
  }

  handleClick = () => {
    this.toggleSaibaMais();
    if(!this.state.botao) {
      this.props.saibaMais(this.props.seleciona)
    } else {
      this.props.saibaMais('');
    }
  }
  
  render = () => {
    let classesBotao = `button button--aylen button--${this.props.cor} ${this.props.selecionado == this.props.seleciona ? `button--hovered` : ``} button--border-medium button--size-m button--round-l button--text-thick`;

    if (this.props.selecionado != this.props.seleciona) {
      this.state = {botao: false}
    }
    return (
      <div className={`card-tab ${this.state.ativo}`}>
        <div className={`card-tab__header card-tab__header--${this.props.cor}`}></div>
        <div className="card-tab__conteudo">
          <h3 className="card-tab__titulo">{this.props.titulo}</h3>
        </div>
        <div className="card-tab__botao">
          <button
            onClick={ () => this.handleClick() }
            className={classesBotao}>
            { this.props.selecionado == this.props.seleciona ? ("Fechar") : ("Saiba Mais") }
          </button>
        </div>
      </div>
    )
  }
}

export { CardTab };